import { InvoiceV2DetailApp } from "InvoiceV2/InvoiceV2DetailApp";
import {
  type RouteObject,
} from "react-router";
import InvoiceV2LandingApp from "InvoiceV2Landing/App";

declare let viewModel: any;

export const invoiceV2Route: RouteObject = {
  path: "invoicev2",
  children: [{
    path: "detail/:key",
    loader: () => viewModel,
    Component: InvoiceV2DetailApp,
  }, {
    path: "invitation/:secret",
    loader: () => viewModel,
    Component: InvoiceV2LandingApp,
  }]
};